import React from 'react'
import PropTypes from 'prop-types'
import cn from 'classnames'
import PreviewImage from '../../PreviewImage/PreviewImage'
import Grid from '../../Grid'
import Typography from '../../Typography'
import trash from '../../../assets/trash.png'
import pen from '../../../assets/pen.png'
import Image from '../../Image/Image'
import styles from './CartItem.module.sass'
import placeholder from '../../../assets/placeholder_elementary.png'
import { studentFullName } from '../../../utils/functions'
import SeniorCartItem from './senior-cart-item'
import AppointmentInfo from './AppointmentInfo';
import AddonPackage from './AddonPackage';

const CartItem = ({
  orderPackage,
  removeItem,
  editItem,
  editable,
  key = 'cart',
}) => {
  if (!orderPackage.apiOption) return null

  const seniorPackage = (orderPackage.sheets.length > 0 && orderPackage.sheets.some((sheet) => sheet.backgroundId)) || orderPackage.seniorImageId
  const addonPackage = orderPackage.sheets.length === 0 && (orderPackage.addonSheets.length > 0 && orderPackage.addonSheets.some((sheet) => sheet.backgroundId));

  if (addonPackage) {
    return (
      <AddonPackage
        editable={editable}
        orderPackage={orderPackage}
        removeItem={removeItem}
      />
    );
  }
  if (seniorPackage) {
    return (
      <SeniorCartItem
        editable={editable}
        orderPackage={orderPackage}
        removeItem={removeItem}
        key={key}
      />
    );
  }

  let placeholderImage = placeholder
  if (orderPackage.studentImage && orderPackage.studentImage.image) {
    placeholderImage = orderPackage.studentImage.image()
  } else if (!orderPackage.package.placeholder.includes('placeholder.png')) {
    placeholderImage = orderPackage.package.placeholderImage()
  }

  return (
    <Grid container>
      <Grid container item direction='column' justify='center' alignItems='center' xs={4}>
        {(orderPackage.studentImage || orderPackage.background) &&
          <Grid item classes={styles.previewImageContainer}>
            <PreviewImage
              accessCodeOnly={orderPackage.student.school.accessCodeOnly}
              isPreviewHidden={false}
              classes={styles.previewImage}
              foregroundUrl={placeholderImage}
              backgroundUrl={orderPackage.background && orderPackage.background.imageUrl}
            />
          </Grid>
        }
        {editable &&
          <Grid item classes={cn(styles.deleteContainer, styles.iconText)} onClick={() => removeItem(orderPackage.id, 'orderPackage')}>
            <Typography>
              <Image classes={styles.imgIcon} src={trash} alt='remove icon' />
              Remove
            </Typography>
          </Grid>
        }
      </Grid>
      <Grid container item direction='column' classes={styles.packageInfoContainer} xs={8}>
        <Grid container item justify='space-between'>
          <Grid item>
            <Typography
              classes={styles.packageName}
              weight={600}
            >
              Package {orderPackage.option && orderPackage.option().name}
            </Typography>
          </Grid>
          {editable &&
            <Grid item classes={styles.iconText} onClick={() => editItem(orderPackage)}>
              <Typography>
                <Image classes={styles.imgIcon} src={pen} alt='remove icon' />
                Edit
              </Typography>
            </Grid>
          }
        </Grid>
        <Grid item>
          <Typography weight={600}>Student: {orderPackage.student && studentFullName(orderPackage.student, true)}</Typography>
        </Grid>
        {orderPackage.appointmentTime && <AppointmentInfo orderPackage={orderPackage} />}
        <Grid container item alignItems='flex-end' justify='space-between' classes={styles.imageTypeList}>
          <Grid item xs={9}>
            {orderPackage.option && orderPackage.option().imageTypes.map(imageType =>
              <Typography key={`${key}-${imageType.id}`}>{imageType.name}</Typography>
            )}
          </Grid>
          <Grid item xs={3}>
            <Typography align='right' weight={600}>
              {orderPackage
                .price
                .toLocaleString('en-US', {
                  style: 'currency', currency: 'USD',
                })
              }
            </Typography>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  )
}

CartItem.defaultProps = {
  editable: true,
  removeItem: () => { },
  editItem: () => { },
}

CartItem.propTypes = {
  orderPackage: PropTypes.object,
  editable: PropTypes.bool,
  removeItem: PropTypes.func,
  editItem: PropTypes.func,
}

export default CartItem
